export default {
  getList: {
    method: 'post',
    url: '/p/vehicle/remooc-category/list'
  },
  add: {
    method: 'post',
    url: '/p/vehicle/remooc-category'
  },
  delete: {
    method: 'delete',
    url: '/p/vehicle/remooc-category'
  },
  archive: {
    method: 'delete',
    url: '/p/vehicle/remooc-category/archive'
  },
  restore: {
    method: 'put',
    url: '/p/vehicle/remooc-category/restore'
  },
  edit: {
    method: 'put',
    url: '/p/vehicle/remooc-category/id'
  },
  find: {
    method: 'get',
    url: '/p/vehicle/remooc-category/find?key=KEY'
  },
  detail: {
    method: 'get',
    url: '/p/vehicle/remooc-category/detail/ID'
  }
}
